// material-ui
import Box from '@mui/material/Box';
import HomeOutlined from '@ant-design/icons/HomeOutlined';
import ShopOutlined from '@ant-design/icons/ShopOutlined';

// project import
import NavGroup from './NavGroup';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const sidebarMenu = {
  id: 'group-sidebar-main',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: HomeOutlined
    },
    {
      id: 'warehouse',
      title: 'Warehouse',
      type: 'item',
      url: '/wareHouse/view',
      icon: ShopOutlined
    }
  ]
};

export default function Navigation() {
  return (
    <Box sx={{ pt: 2, pb: 1 }}>
      <NavGroup key={sidebarMenu.id} item={sidebarMenu} />
    </Box>
  );
}
